import React, { useMemo } from 'react';

const MantraOverlay = ({
    text,
    caption,
    highlight = null,
    dyslexicFont = false,
    highContrast = false,
    className = ''
}) => {
    const renderText = useMemo(() => {
        if (!text) return null;

        const syllables = text.split(' ');

        return syllables.map((syllable, index) => {
            const isHighlighted = highlight &&
                index >= highlight[0] &&
                index <= highlight[1];

            return (
                <span
                    key={index}
                    className={`inline-block mx-1 px-2 py-1 rounded transition-all duration-300 ${
                        isHighlighted
                            ? highContrast
                                ? 'bg-yellow-400 text-black shadow-lg transform scale-110'
                                : 'bg-blue-500 bg-opacity-80 text-white shadow-lg transform scale-110'
                            : 'bg-black bg-opacity-40'
                    }`}
                    style={{
                        animationDelay: `${index * 100}ms`
                    }}
                >
                    {syllable}
                </span>
            );
        });
    }, [text, highlight, highContrast]);

    const fontClass = dyslexicFont
        ? 'font-mono' // Using monospace as a dyslexic-friendly alternative
        : 'font-serif';

    const textColor = highContrast
        ? 'text-yellow-300'
        : 'text-white';

    const shadowClass = highContrast
        ? 'drop-shadow-[0_2px_4px_rgba(0,0,0,0.8)]'
        : 'drop-shadow-[0_2px_4px_rgba(0,0,0,0.5)]';

    if (!text && !caption) return null;

    return (
        <div className={`text-center px-8 ${className}`}>
            {/* Main Mantra Text */}
            {text && (
                <div className={`mb-6 ${shadowClass}`}>
                    <div
                        className={`text-4xl md:text-6xl lg:text-7xl ${fontClass} ${textColor} leading-tight`}
                        style={{
                            textShadow: highContrast
                                ? '2px 2px 4px rgba(0,0,0,0.9)'
                                : '1px 1px 3px rgba(0,0,0,0.7)'
                        }}
                    >
                        {renderText}
                    </div>
                </div>
            )}

            {/* Caption */}
            {caption && (
                <div
                    className={`bg-black bg-opacity-60 rounded-lg px-6 py-3 mx-auto max-w-2xl ${shadowClass}`}
                >
                    <p className={`text-lg md:text-xl ${fontClass} ${textColor}`}>
                        {caption}
                    </p>
                </div>
            )}

            {/* Pronunciation Guide (if needed) */}
            {text && text.includes('OM') && (
                <div className="mt-4 text-center">
                    <button
                        className={`text-sm ${textColor} opacity-70 hover:opacity-100 transition-opacity underline`}
                        onClick={() => {
                            // TODO: Add pronunciation audio or guide
                            console.log('Pronunciation guide requested');
                        }}
                    >
                        Pronunciation Guide
                    </button>
                </div>
            )}
        </div>
    );
};

export default MantraOverlay;